export default "__VITE_ASSET__774c6908__$_?nuxt_component=async__"